module.exports = __webpack_public_path__ + "static/media/home-credit-logo.f743fd99.jpg";